/* GKIKZ Cart Upsell — quick-add modal flow. v1.4 (cart-mode aware)
   Click "+ ADD" → opens bottom-sheet modal with title/image/price prefilled
   from button data attrs, uses prefetched product cache for instant variant
   rendering, shows skeleton shimmer while options/cache loads. After ATC →
   success view with "Back to cart" and "Checkout" CTAs.
   Cart mode: respects window.__gkikzCartMode — any non-'overlay' value
   (Krown 'no-overlay', or 'page') means the cart is a full /cart page, so
   closing the modal after ATC navigates to /cart instead of opening a drawer.
*/
(function () {
  if (window.__gkikzUpsellInit) return;
  window.__gkikzUpsellInit = true;

  var modal = null;
  var currentProduct = null;
  var selectedVariant = null;
  var selectedOptions = {};
  var currentDiscountCode = '';
  var currentDiscountPct = 0;
  var currentSizeChartHtml = '';
  var didAddToCart = false;

  function $(sel, root) { return (root || modal).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || modal).querySelectorAll(sel)); }

  function getCartMode() {
    return (typeof window.__gkikzCartMode === 'string' ? window.__gkikzCartMode : 'overlay').toLowerCase();
  }
  function isPageMode() {
    return getCartMode() !== 'overlay';
  }

  function getActiveCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return null;
  }

  function getCurrencyRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      var r = parseFloat(window.Shopify.currency.rate);
      if (!isNaN(r) && r > 0) return r;
    }
    return 1;
  }

  var _moneyFormatter = null;
  var _moneyFormatterCurrency = null;
  function getMoneyFormatter() {
    var currency = getActiveCurrency();
    if (!currency) return null;
    if (_moneyFormatter && _moneyFormatterCurrency === currency) return _moneyFormatter;
    try {
      _moneyFormatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      _moneyFormatterCurrency = currency;
    } catch (e) {
      _moneyFormatter = null;
    }
    return _moneyFormatter;
  }

  function formatMoney(cents) {
    var n = Number(cents) || 0;
    var sign = n < 0 ? '-' : '';
    n = Math.abs(n);

    var fmt = getMoneyFormatter();
    if (fmt) {
      var rate = getCurrencyRate();
      var converted = n * rate;
      return sign + fmt.format(converted / 100);
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
      return sign + window.Shopify.formatMoney(n, moneyFormat);
    }

    return sign + '$' + (n / 100).toFixed(2);
  }

  function setMoneyText(el, cents) {
    if (!el) return;
    if (!el.classList.contains('money')) el.classList.add('money');
    el.textContent = formatMoney(cents);
  }

  function injectStyles() {
    if (document.getElementById('gkikz-qa-skeleton-styles')) return;
    var s = document.createElement('style');
    s.id = 'gkikz-qa-skeleton-styles';
    s.textContent = [
      '.gkikz-qa-skeleton-group { margin: 12px 0 16px; }',
      '.gkikz-qa-skeleton-label { width: 56px; height: 9px; background: #ececec; border-radius: 3px; margin-bottom: 10px; animation: gkikzQaShimmer 1.2s ease-in-out infinite; }',
      '.gkikz-qa-skeleton-btns { display: flex; gap: 6px; flex-wrap: wrap; }',
      '.gkikz-qa-skeleton-pill { display: inline-block; width: 44px; height: 32px; background: #ececec; border-radius: 3px; animation: gkikzQaShimmer 1.2s ease-in-out infinite; }',
      '.gkikz-qa-skeleton-pill:nth-child(2) { animation-delay: 0.15s; }',
      '.gkikz-qa-skeleton-pill:nth-child(3) { animation-delay: 0.30s; }',
      '.gkikz-qa-skeleton-pill:nth-child(4) { animation-delay: 0.45s; }',
      '.gkikz-qa-skeleton-pill:nth-child(5) { animation-delay: 0.60s; }',
      '@keyframes gkikzQaShimmer { 0%,100% { opacity: 1; } 50% { opacity: 0.45; } }',
      '@media (prefers-reduced-motion: reduce) { .gkikz-qa-skeleton-label, .gkikz-qa-skeleton-pill { animation: none; opacity: 0.7; } }'
    ].join('\n');
    document.head.appendChild(s);
  }

  function showView(name) {
    $$('[data-qa-view]').forEach(function (el) {
      if (el.dataset.qaView === name) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function renderSkeletonOptions() {
    $('[data-qa-options]').innerHTML =
      '<div class="gkikz-qa-skeleton-group">' +
        '<div class="gkikz-qa-skeleton-label"></div>' +
        '<div class="gkikz-qa-skeleton-btns">' +
          '<span class="gkikz-qa-skeleton-pill"></span>' +
          '<span class="gkikz-qa-skeleton-pill"></span>' +
        '</div>' +
      '</div>' +
      '<div class="gkikz-qa-skeleton-group">' +
        '<div class="gkikz-qa-skeleton-label"></div>' +
        '<div class="gkikz-qa-skeleton-btns">' +
          '<span class="gkikz-qa-skeleton-pill"></span>' +
          '<span class="gkikz-qa-skeleton-pill"></span>' +
          '<span class="gkikz-qa-skeleton-pill"></span>' +
          '<span class="gkikz-qa-skeleton-pill"></span>' +
          '<span class="gkikz-qa-skeleton-pill"></span>' +
        '</div>' +
      '</div>';
  }

  function openModal(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    currentDiscountCode = btn.getAttribute('data-discount-code') || '';
    currentDiscountPct = parseInt(btn.getAttribute('data-discount-pct'), 10) || 0;
    currentSizeChartHtml = btn.getAttribute('data-sizechart-html') || '';
    var reviewsRating = parseFloat(btn.getAttribute('data-reviews-rating'));
    var reviewsCount = parseInt(btn.getAttribute('data-reviews-count'), 10) || 0;

    var initialTitle = btn.getAttribute('data-product-title') || '';
    var initialImg = btn.getAttribute('data-product-image') || '';
    var initialPrice = parseInt(btn.getAttribute('data-product-price'), 10) || 0;
    var initialCompare = parseInt(btn.getAttribute('data-product-compare'), 10) || 0;

    didAddToCart = false;

    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    showView('picker');

    var titleEl = $('[data-qa-title]');
    var imgEl = $('[data-qa-img]');
    var nowEl = $('[data-qa-price-now]');
    var wasEl = $('[data-qa-price-was]');
    var badgeEl = $('[data-qa-badge]');

    if (titleEl) titleEl.textContent = initialTitle;
    if (imgEl) {
      if (initialImg) { imgEl.src = initialImg; imgEl.alt = initialTitle; }
      else imgEl.removeAttribute('src');
    }

    var initialDisplay = currentDiscountPct > 0
      ? Math.round(initialPrice * (100 - currentDiscountPct) / 100)
      : initialPrice;
    if (nowEl) setMoneyText(nowEl, initialDisplay);

    var initialWas = null;
    if (currentDiscountPct > 0) initialWas = initialPrice;
    else if (initialCompare > initialPrice) initialWas = initialCompare;
    if (wasEl) {
      if (initialWas) { setMoneyText(wasEl, initialWas); wasEl.removeAttribute('hidden'); }
      else wasEl.setAttribute('hidden', '');
    }
    if (badgeEl) {
      if (currentDiscountPct > 0) { badgeEl.textContent = currentDiscountPct + '% OFF'; badgeEl.removeAttribute('hidden'); }
      else badgeEl.setAttribute('hidden', '');
    }

    renderSkeletonOptions();
    setATC(true, 'SELECT OPTIONS');

    syncSizeChart();
    var content = modal.querySelector('[data-qa-sizechart-content]');
    var toggle = modal.querySelector('[data-qa-sizechart-toggle]');
    if (content) content.setAttribute('hidden', '');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.classList.remove('open'); }

    var ratingEl = $('[data-qa-rating]');
    if (ratingEl && reviewsRating > 0 && reviewsCount > 0) {
      ratingEl.removeAttribute('hidden');
      $('[data-qa-stars]').innerHTML = renderStars(reviewsRating);
      $('[data-qa-rating-count]').textContent = reviewsCount + ' reviews';
    } else if (ratingEl) {
      ratingEl.setAttribute('hidden', '');
    }

    var cached = window.__gkikzProductCache && window.__gkikzProductCache[handle];
    if (cached) {
      currentProduct = cached;
      renderProduct(cached, reviewsRating, reviewsCount);
      return;
    }

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        currentProduct = product;
        if (!window.__gkikzProductCache) window.__gkikzProductCache = {};
        window.__gkikzProductCache[handle] = product;
        renderProduct(product, reviewsRating, reviewsCount);
      })
      .catch(function () {
        if (titleEl) titleEl.textContent = 'Failed to load product';
      });
  }

  function closeModal() {
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    if (didAddToCart) {
      didAddToCart = false;
      if (isPageMode()) {
        window.location.href = '/cart';
        return;
      }
      if (typeof window.refreshCart === 'function') {
        try { window.refreshCart(true); } catch (e) { window.location.reload(); }
      } else {
        window.location.reload();
      }
    }
  }

  function renderProduct(product, reviewsRating, reviewsCount) {
    var heroImg = (product.featured_image) || (product.media && product.media[0] && product.media[0].src) || '';
    var imgEl = $('[data-qa-img]');
    if (imgEl && heroImg && imgEl.src !== heroImg) imgEl.src = heroImg;
    if (imgEl) imgEl.alt = product.title;
    var titleEl = $('[data-qa-title]');
    if (titleEl) titleEl.textContent = product.title;

    var ratingEl = $('[data-qa-rating]');
    if (ratingEl && reviewsRating > 0 && reviewsCount > 0) {
      ratingEl.removeAttribute('hidden');
      $('[data-qa-stars]').innerHTML = renderStars(reviewsRating);
      $('[data-qa-rating-count]').textContent = reviewsCount + ' reviews';
    }

    renderOptions(product);
  }

  function renderStars(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var fill;
      if (rating >= i) fill = 'full';
      else if (rating >= i - 0.5) fill = 'half';
      else fill = 'empty';
      html += '<span class="gkikz-qa-star gkikz-qa-star--' + fill + '">★</span>';
    }
    return html;
  }

  function renderOptions(product) {
    var container = $('[data-qa-options]');
    container.innerHTML = '';
    selectedOptions = {};

    var optionNames = (product.options || []).map(function (o) {
      return (typeof o === 'string') ? o : (o && o.name) ? o.name : '';
    });

    var hasRealOptions = !(product.variants.length === 1 && product.variants[0].title === 'Default Title');

    if (!hasRealOptions) {
      selectedVariant = product.variants[0];
      updatePrice();
      setATC(false, 'ADD TO CART');
      return;
    }

    optionNames.forEach(function (optionName, idx) {
      var values = [];
      product.variants.forEach(function (v) {
        var val = (v.options && v.options[idx]) || v['option' + (idx + 1)];
        if (val && values.indexOf(val) === -1) values.push(val);
      });

      var group = document.createElement('div');
      group.className = 'gkikz-qa-option-group';

      var label = document.createElement('div');
      label.className = 'gkikz-qa-option-label';
      label.innerHTML = '<span class="gkikz-qa-option-name">' + escapeHtml(optionName) + ':</span> <strong data-qa-selected="' + idx + '"></strong>';
      group.appendChild(label);

      var btns = document.createElement('div');
      btns.className = 'gkikz-qa-option-btns';
      values.forEach(function (value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'gkikz-qa-option-btn';
        b.textContent = value;
        b.setAttribute('data-option-index', idx);
        b.setAttribute('data-option-value', value);
        b.addEventListener('click', function () { selectOption(idx, value); });
        btns.appendChild(b);
      });
      group.appendChild(btns);
      container.appendChild(group);
    });

    var firstAvailable = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { firstAvailable = product.variants[i]; break; }
    }
    if (!firstAvailable) firstAvailable = product.variants[0];
    var firstOpts = firstAvailable.options || [firstAvailable.option1, firstAvailable.option2, firstAvailable.option3].filter(Boolean);
    firstOpts.forEach(function (val, idx) { selectOption(idx, val); });
  }

  function selectOption(idx, value) {
    selectedOptions[idx] = value;

    $$('[data-option-index="' + idx + '"]').forEach(function (b) {
      if (b.getAttribute('data-option-value') === value) b.classList.add('selected');
      else b.classList.remove('selected');
    });
    var labelEl = $('[data-qa-selected="' + idx + '"]');
    if (labelEl) labelEl.textContent = value;

    updateAvailability();
    updateSelectedVariant();
  }

  function updateAvailability() {
    if (!currentProduct) return;
    $$('.gkikz-qa-option-btn').forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-option-value');
      var anyMatch = currentProduct.variants.some(function (v) {
        if (!v.available) return false;
        var vOpts = v.options || [v.option1, v.option2, v.option3];
        if (vOpts[i] !== value) return false;
        for (var j = 0; j < vOpts.length; j++) {
          if (j === i) continue;
          if (typeof selectedOptions[j] !== 'undefined' && selectedOptions[j] !== vOpts[j]) {
            return false;
          }
        }
        return true;
      });
      if (anyMatch) btn.classList.remove('sold-out');
      else btn.classList.add('sold-out');
    });
  }

  function updateSelectedVariant() {
    if (!currentProduct) return;
    var optionValues = currentProduct.options.map(function (_, i) { return selectedOptions[i]; });
    if (optionValues.some(function (v) { return typeof v === 'undefined'; })) {
      selectedVariant = null;
      setATC(true, 'SELECT OPTIONS');
      return;
    }
    selectedVariant = currentProduct.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === optionValues[i]; });
    });
    if (!selectedVariant) {
      setATC(true, 'UNAVAILABLE');
      return;
    }
    if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
      $('[data-qa-img]').src = selectedVariant.featured_image.src;
    }
    updatePrice();
    if (selectedVariant.available) {
      setATC(false, 'ADD TO CART');
    } else {
      setATC(true, 'SOLD OUT');
    }
  }

  function updatePrice() {
    if (!selectedVariant) return;
    var nowEl = $('[data-qa-price-now]');
    var wasEl = $('[data-qa-price-was]');
    var badgeEl = $('[data-qa-badge]');

    var displayPrice = selectedVariant.price;
    if (currentDiscountPct > 0) {
      displayPrice = Math.round(selectedVariant.price * (100 - currentDiscountPct) / 100);
    }
    setMoneyText(nowEl, displayPrice);

    var wasPrice = null;
    if (currentDiscountPct > 0) {
      wasPrice = selectedVariant.price;
    } else if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
      wasPrice = selectedVariant.compare_at_price;
    }
    if (wasPrice) {
      setMoneyText(wasEl, wasPrice);
      wasEl.removeAttribute('hidden');
    } else {
      wasEl.setAttribute('hidden', '');
    }
    if (currentDiscountPct > 0) {
      badgeEl.textContent = currentDiscountPct + '% OFF';
      badgeEl.removeAttribute('hidden');
    } else {
      badgeEl.setAttribute('hidden', '');
    }
  }

  function setATC(disabled, text) {
    var atc = $('[data-qa-atc]');
    atc.disabled = disabled;
    atc.textContent = text;
  }

  function addToCart() {
    if (!selectedVariant) return;
    setATC(true, 'ADDING...');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: selectedVariant.id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (currentDiscountCode) {
          return fetch('/discount/' + encodeURIComponent(currentDiscountCode), {
            method: 'GET', credentials: 'same-origin', redirect: 'manual'
          }).catch(function () {});
        }
      })
      .then(function () {
        didAddToCart = true;
        showSuccess();
      })
      .catch(function () {
        setATC(false, 'ADD TO CART');
      });
  }

  function showSuccess() {
    var img = (selectedVariant.featured_image && selectedVariant.featured_image.src) || currentProduct.featured_image;
    $('[data-qa-success-img]').src = img;
    $('[data-qa-success-title]').textContent = currentProduct.title;
    $('[data-qa-success-variant]').textContent = selectedVariant.title === 'Default Title' ? '' : selectedVariant.title;

    var displayPrice = selectedVariant.price;
    if (currentDiscountPct > 0) {
      displayPrice = Math.round(selectedVariant.price * (100 - currentDiscountPct) / 100);
    }
    setMoneyText($('[data-qa-success-price-now]'), displayPrice);
    var wasEl = $('[data-qa-success-price-was]');
    var wasPrice = currentDiscountPct > 0 ? selectedVariant.price : (selectedVariant.compare_at_price > selectedVariant.price ? selectedVariant.compare_at_price : null);
    if (wasPrice) {
      setMoneyText(wasEl, wasPrice);
      wasEl.removeAttribute('hidden');
    } else {
      wasEl.setAttribute('hidden', '');
    }
    $('[data-qa-checkout]').href = '/checkout';
    showView('success');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function syncSizeChart() {
    if (!modal) return;
    var target = modal.querySelector('[data-qa-sizechart-target]');
    if (!target) return;
    var wrap = modal.querySelector('.gkikz-qa-sizechart-wrap');
    if (currentSizeChartHtml) {
      target.innerHTML = currentSizeChartHtml;
      if (wrap) wrap.style.display = '';
    } else {
      target.innerHTML = '';
      if (wrap) wrap.style.display = 'none';
    }
  }

  function ensureModal() {
    if (modal && document.contains(modal)) return modal;
    modal = document.getElementById('gkikz-quickadd-modal');
    if (!modal) return null;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function attach() {
    injectStyles();

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-gkikz-upsell-btn]');
      if (openBtn && !openBtn.disabled) {
        e.preventDefault();
        if (!ensureModal()) {
          console.warn('GKIKZ: Quick-add modal not found in DOM');
          return;
        }
        openModal(openBtn);
        return;
      }

      if (!modal) return;
      if (e.target.closest('[data-qa-close]') || e.target.closest('[data-qa-backtocart]')) {
        e.preventDefault();
        closeModal();
      } else if (e.target.closest('[data-qa-atc]')) {
        e.preventDefault();
        addToCart();
      } else if (e.target.closest('[data-qa-sizechart-toggle]')) {
        e.preventDefault();
        var toggle = e.target.closest('[data-qa-sizechart-toggle]');
        var content = modal.querySelector('[data-qa-sizechart-content]');
        if (!content) return;
        var isOpen = !content.hasAttribute('hidden');
        if (isOpen) {
          content.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.classList.remove('open');
        } else {
          content.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
          toggle.classList.add('open');
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
